module.exports = __webpack_public_path__ + "static/media/icon-piece-loa-05.5d43a165.png";